import { Gender } from './clients.models';
import { FormControl } from '@angular/forms';
import { IdType } from './intermediary.model';
import { IBranch } from './branches.model';
import { IBaseModel } from './base.model';

export type UserStatus = 'Active' | 'Suspended' | 'Deleted';

export type UserType =
  | 'Admin'
  | 'InsurerRepresentative'
  | 'BrokerRepresentative'
  | 'AgentRepresentative'
  | 'PartnerRepresentative'
  | 'AdminPartnerRepresentative';

export const permissionsPathMap: Record<UserType, string> = {
  Admin: 'admin',
  InsurerRepresentative: 'insurer',
  BrokerRepresentative: 'intermediary',
  AgentRepresentative: 'intermediary',
  PartnerRepresentative: 'partner',
  AdminPartnerRepresentative: 'partner',
};

export const systemUserRoles: string[] = [
  'Admin',
  'PartnerApi',
  'InsurerRepresentative',
  'BrokerRepresentative',
  'AgentRepresentative',
  'AdminAgentRepresentative',
  'PartnerRepresentative',
  'AdminPartnerRepresentative',
  'Client',
];

export function filterOutSystemRoles(roles: string[]) {
  return roles.filter((role) => !systemUserRoles.includes(role));
}

export interface IRepresentativeRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  type: IdType;
  idNumber: string;
  physicalAddress: string;
  gender: Gender;
  roles: string[];
  branchId?: number | null;
}

export interface IRepresentative extends IBaseModel {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  type: IdType;
  idNumber: string;
  physicalAddress: string;
  gender: Gender;
  branch?: IBranch;
  branchId: number | null;
  roles: string[];
  status: UserStatus;
  lastSeen: Date;
  twoFactorEnabled?: boolean;
}

export interface IUserStats {
  totalUsers: number;
  activeUsers: number;
  suspendedUsers: number;
  deletedUsers: number;
}

export interface UpdateRepresentativePassword {
  email: string;
  userId: number;
  newPassword: string;
}

export interface IRepresentativeForm {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  email: FormControl<string>;
  phoneNumber: FormControl<string>;
  type: FormControl<IdType>;
  roles: FormControl<string[]>;
  idNumber: FormControl<string>;
  physicalAddress: FormControl<string>;
  gender: FormControl<Gender>;
  branchId: FormControl<number>;
}
